import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminLayout from "../Components/Layouts/AdminLayout/AdminLayout";
import Home from "../Pages/Home";
import Inputs from "../Pages/Admin/Inputs";
import Leads from "../Pages/Admin/Leads";
import Login from "../Pages/Login";

type Props = {};

const Router = (props: Props) => {
  return (
    <Routes>
      <Route path="/:domain?" element={<Home />} />
      <Route path="/login" element={<Login />} />

      <Route path="/admin" element={<AdminLayout />}>
        <Route path="/admin/leads" element={<Leads />} />
        <Route path="/admin/inputs" element={<Inputs />} />
      </Route>
    </Routes>
  );
};

export default Router;
